import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAccessAssistants, loadMoreAssistants } from '../../../redux/customers/customersActions';

const useAccessAssistantsOptions = ({ search }) => {
  const dispatch = useDispatch();

  const accessAssistants = useSelector((state) => state.customers.accessAssistants);

  const mappedAccessAssistants = useMemo(
    () => accessAssistants.map(({ id, name }) => ({ id, name: name, value: id, label: name })),
    [accessAssistants],
  );

  const handleLoadMoreAssistants = useCallback(
    (newPage) => {
      dispatch(loadMoreAssistants({ page: newPage, searchQuery: search }));
    },
    [dispatch, search],
  );

  useEffect(() => {
    dispatch(getAccessAssistants({ page: 1, searchQuery: search }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return useMemo(
    () => ({
      accessAssistants: mappedAccessAssistants,
      handleLoadMoreAssistants,
    }),
    [mappedAccessAssistants, handleLoadMoreAssistants],
  );
};

export default useAccessAssistantsOptions;
